import React from "react";
import useLottieRef from "hooks/useLottieRef";
import Lottie, { LottieComponentProps } from "lottie-react";

type Props = LottieComponentProps & {
  speed: number;
};

const CustomLottie: React.FC<Props> = ({ speed = 1, ...props }) => {
  const ref = useLottieRef({ speed });

  return <Lottie lottieRef={ref} {...props} />;
};

export default CustomLottie;
